import Vue  from 'vue'
import moment from 'moment-timezone'
import {ACD_RESET_STATUS_TIMER} from './misc.conf.js'

// Exports an Singelton https://k94n.com/es6-modules-single-instance-pattern

export default new Vue({



  data: {
    config:{
      path: '',
    },
    
    call: {
      id:0,
      idCompanyCallCenter: 0,
      idCompanyClient: 0,
      idCompanyCaller: 0,
      idUserCallCenter: 0,
      idUserClient: 0,
      idUserCaller: 0,
      calledNumber: '',
      callingNumber: '',
      datetimeBegin: '',
      datetimeEnd: '',
      message: '',
      messageStatus: '',
      idsKomboxUserCaller: [],
    },

    shipping:{
      idsUserClient: [], 
      idsCompanyClient: [],
    },
    
    cache:{
      companyClient: {},
      userClient: {},
      userCaller: {},
    },
    
    login:{},

  },
  
  created: function () {
    console.log('bus:created');

    if (window.location.hostname.includes('localhost')){
      this.config.path = 'http://cc-pronto4.cmx.localhost/';
    }
    else if(window.location.hostname.includes('staging'))
    {
      this.config.path = 'https://staging-cc-pronto4-backend.cmx-solutions.com/';
    }
    else if(window.location.hostname.includes('agent'))
    {
      this.config.path = 'https://agent-backend.cc-pronto.cmx-solutions.com/';
    }
    else{
      this.config.path = 'https://cc-pronto4-backend.cmx-solutions.com/';
    }

    // Sind wir angemeldet (nach F5)?
    let loginData = JSON.parse(sessionStorage.getItem("login"));
    if(loginData){
      this.setLogin(loginData);
    }else{
      this.resetLogin();
    }

    
    
    if(0){
      this.registerOnLogin(this.onDebug);

      this.registerOnIdCompanyClient(this.onDebug);
      this.registerOnIdUserClient(this.onDebug);
      this.registerOnIdUserCaller(this.onDebug);
      this.registerOnNewUserCaller(this.onDebug);
      
      this.registerAddKomboxUserCaller(this.onDebug);
      this.registerRemoveKomboxUserCaller(this.onDebug);
      this.registerResetKomboxUserCaller(this.onDebug);

      this.registerOnCompanyCaller(this.onDebug);
      
      this.registerOnAddMessage(this.onDebug);
      
    }
    
  },

  
  methods: {
    
    /* not Used, only a sample...
    getCompanyClient: function () {
      return this.models.companyClient;
    },
    
    resetCompanyClient: function () {
      for (const prop of Object.getOwnPropertyNames(this.models.companyClient)) {
        delete this.models.companyClient[prop];
        //this.models.companyClient[prop] = '';
      }
    },
    */
    
    
    resetCall: function () {
      this.call.id = 0;
      this.call.idCompanyCallCenter =  this.login.companyCallCenter.id;
      this.call.idCompanyClient = 0;
      this.call.calledNumber = '';
      this.call.callingNumber = '';
      this.call.idCompanyCaller = 0;
      this.call.idUserCallCenter = this.login.userCallCenter.idCallUserCallCenter;
      this.call.idUserClient = 0;
      this.call.idUserCaller = 0;
      this.call.datetimeBegin =  '';
      this.call.datetimeEnd = '';
      this.call.message = '';
      this.call.messageStatus = '';
      this.call.idsKomboxUserCaller.splice(0 , this.call.idsKomboxUserCaller.length); // array leeren da referenz ;

    },
    
    
    
    
    onDebug: function (id, event , call) {
      console.log('bus:onDebug:' + event + ':' + id );
      console.log(JSON.stringify(this.$data, null, 2));
    },

    
    /* Login */
    


    resetLogin: function () {
        this.login = {};
        this.loggedIn = false;
        this.login.dateTime = false;
        this.login.userCallCenter = {};  
        this.login.companyCallCenter = {};
        sessionStorage.removeItem("login");
    },

    setLogin: function (loginData) {
      this.login = loginData;
      this.login.loggedIn = true;
      this.login.dateTime = new Date();

      sessionStorage.setItem("login",JSON.stringify(this.login));
      
      // Wir setzten schon mal die Werte für den Call
      this.call.idUserCallCenter = loginData.userCallCenter.idCallUserCallCenter;
      this.call.idCompanyCallCenter = loginData.companyCallCenter.id;
    },

    emitLogin: function (loginData) {
      console.info('bus:emitLogin deprecated - no function - use setLogin(loginData)')
      //this.setLogin(loginData)
      // Logindaten persistent speichern wg. F5
      //sessionStorage.setItem("login",JSON.stringify(loginData));
      //this.$emit('onLogin',loginData, 'onLogin', this.call);
    },

    registerOnLogin: function (fn) {
      console.info('bus:registerOnLogin deprecated - no function')
      //this.$on('onLogin',fn);
    },

    isLoggedIn: function () {
      return !!this.login.loggedIn;
    },
    
    logout: function(cause) {
      this.resetLogin();
      this.resetCall();
      this.$off();
    },

    emitLogout: function(cause) {
      console.info('bus:emitLogout deprecated - no function - use resetLogin(logout)')
      //this.resetLogin();
      //this.resetCall();
      //sessionStorage.removeItem("login");
      //this.$emit('onLogout', cause, 'onLogout', this.call);
    },
    
    registerOnLogout: function (fn) {
      console.info('bus:registerOnLogout deprecated - no function - use bus.isLoggedIn()')
      //this.$on('onLogout',fn);
    },
    
    getLoginData(){
      return this.login;
    },



    
    /* CompanyClient (Auftraggeber) */

    emitIdCompanyClient: function (idCompanyClient) {
      // Nur verschicken wenn sich etwas ändert
      if(this.call.idCompanyClient != idCompanyClient){
        this.call.idCompanyClient = idCompanyClient;
        this.$emit('onIdCompanyClient',idCompanyClient, 'onIdCompanyClient', this.call);
      }
    },
    registerOnIdCompanyClient: function (fn) {
      this.$on('onIdCompanyClient',fn);
    },
    
    // Bescheid geben wenn der Company Client nicht mehr gültig ist
    emitResetCompanyClient: function () {
      this.cache.companyClient = {};
      this.$emit('onResetCompanyClient', null, 'onResetCompanyClient', this.call);
    },
    registerOnResetCompanyClient: function (fn) {
      this.$on('onResetCompanyClient',fn);
    },

    // Bescheid geben wenn ein CompanyClient geladen wurde
    emitCompanyClient: function (companyClient) {
      this.cache.companyClient = companyClient;
      this.$emit('onCompanyClient',companyClient, 'onCompanyClient', this.call);
    },
    registerOnCompanyClient: function (fn) {
      this.$on('onCompanyClient',fn);
    },
    
    

    /* UserClient */
    emitIdUserClient: function (idUserClient, force) {
      
      if(this.call.idUserClient != idUserClient || force ){
        this.call.idUserClient = idUserClient;
        this.$emit('onIdUserClient',idUserClient, 'onIdUserClient', this.call );
      }
    },
    registerOnIdUserClient: function (fn) {
      this.$on('onIdUserClient',fn);
    },

    // Bescheid geben wenn der User Client nicht mehr gültig ist
    emitResetUserClient: function () {
      this.cache.userClient = {};
      this.call.idUserClient = 0;
      this.$emit('onResetUserClient', null, 'onResetUserClient', this.call);
    },
    registerOnResetUserClient: function (fn) {
      this.$on('onResetUserClient',fn);
    },

    // Bescheid geben wenn ein UserClient geladen wurde
    emitUserClient: function (userClient) {
      this.cache.userClient = userClient;
      this.call.idUserClient = userClient.id;
      this.$emit('onUserClient',userClient, 'onUserClient', this.call);
    },
    registerOnUserClient: function (fn) {
      this.$on('onUserClient',fn);
    },
    
    
    
    /* UserCaller */

    emitIdUserCaller: function (idUserCaller) {
      if(idUserCaller == 0){
        this.emitResetUserCaller()
      }else{
        this.call.idUserCaller = idUserCaller;
      }
      // immer verschicken, auch wenn 0
      this.$emit('onIdUserCaller',idUserCaller, 'onIdUserCaller', this.call );
    },
    registerOnIdUserCaller: function (fn) {
      this.$on('onIdUserCaller',fn);
    },

    emitUserCaller: function (userCaller) {
      // Nur verschicken wenn sich etwas ändert
      if(this.cache.userCaller != userCaller){
        this.cache.userCaller = userCaller;
        this.$emit('onUserCaller',userCaller, 'onUserCaller', this.call );
      };
    },
    registerOnUserCaller: function (fn) {
      this.$on('onUserCaller',fn);
    },

    emitResetUserCaller: function () {
      this.cache.userCaller = {};
      // Nur verschicken wenn sich etwas ändert
      if(this.call.idUserCaller != 0){
        this.call.idUserCaller = 0;
        this.$emit('onResetUserCaller',null, 'onResetUserCaller', this.call );
      }
    },
    registerOnResetUserCaller: function (fn) {
      this.$on('onResetUserCaller',fn);
    },

    emitNewUserCaller: function (name) {
      this.emitResetUserCaller();
      this.$emit('onNewUserCaller',name, 'onNewUserCaller', this.call );
    },
    registerOnNewUserCaller: function (fn) {
      this.$on('onNewUserCaller',fn);
    },

    emitEditUserCaller: function (userCaller) {
      this.emitResetUserCaller();
      this.$emit('onEditUserCaller',userCaller, 'onEditUserCaller', this.call );
    },
    registerOnEditUserCaller: function (fn) {
      this.$on('onEditUserCaller',fn);
    },

    emitCloneUserCaller: function (userCaller) {
      this.emitResetUserCaller();
      this.$emit('onCloneUserCaller',userCaller, 'onCloneUserCaller', this.call );
    },
    registerOnCloneUserCaller: function (fn) {
      this.$on('onCloneUserCaller',fn);
    },
    

    
    
    /* CompanyCaller */
    emitCompanyCaller: function (companyCaller) {
      this.call.idCompanyCaller = companyCaller.id;
      this.$emit('onCompanyCaller',companyCaller, 'onCompanyCaller', this.call );
    },
    registerOnCompanyCaller: function (fn) {
      this.$on('onCompanyCaller',fn);
    },

    emitNewCompanyCaller: function (name) {
      this.$emit('onNewCompanyCaller',name, 'onNewCompanyCaller', this.call );
    },
    registerOnNewCompanyCaller: function (fn) {
      this.$on('onNewCompanyCaller',fn);
    },
    
    
    /* Message */
    emitAddMessage: function (message) {
      this.$emit('onAddMessage',message, 'onAddMessage', this.call );
    },
    registerOnAddMessage: function (fn) {
      this.$on('onAddMessage',fn);
    },

    /* Suchstring in der Message an Typahead */ 
    emitMessageSearch: function (message) {
      this.$emit('onMessageSearch',message, 'onMessageSearch', this.call );
    },
    registerOnMessageSearch: function (fn) {
      this.$on('onMessageSearch',fn);
    },
  
    /* MessageStatus */
    emitMessageStatus: function (messageStatus) {
      this.$emit('onMessageStatus',messageStatus, 'onMessageStatus', this.call );
    },
    registerOnMessageStatus: function (fn) {
      this.$on('onMessageStatus',fn);
    },

    /* ACD Intervall */
    emitStopAcdInterval: function () {
      this.$emit('stopAcdInterval',null, 'stopAcdInterval', this.call );
    },
    registerStopAcdInterval: function (fn) {
      this.$on('stopAcdInterval',fn);
    },
    
    

    /* Call/Shipping handling */
    
    getCall(){
      return this.call;
    },

    getIdsShipping(){
      return this.shipping.idsUserClient.concat(this.shipping.idsCompanyClient);
    },
    
    callBegin: function (idCompany, idUserClient, calledNumber, callingNumber) {
      // datetimeBegin Serverseitig setzten ??
      this.call.datetimeBegin = moment().tz('Europe/Berlin').format('YYYY-MM-DD HH:mm:ss');
      this.call.calledNumber = typeof(calledNumber) != 'undefined' ? calledNumber : '???';
      this.call.callingNumber = typeof(callingNumber) != 'undefined' ? callingNumber : '???';
      
      this.emitIdCompanyClient(idCompany);
      this.emitIdUserClient(idUserClient, true);
      //this.emitIdUserCaller(0);
    },

    callEnd: function (type, cbOk, cbErr) {
      
      // EndTime Serverseitig setzten ??
      this.call.datetimeEnd = moment().tz('Europe/Berlin').format('YYYY-MM-DD HH:mm:ss');
      
      let container = {
        call: this.call,
        idsShipping: this.getIdsShipping()
      };

      
      this.$http.post(this.config.path + '/callexit/' + type, container).then((response) => {
        //console.log(JSON.stringify(response.body, null, 2));
        
        // alles ok ? Wurde Call Id gesetzt ?
        if(response.status != 200 && typeof response.body.call.id !== 'string'){
          cbErr(response);
          return;
        }
        
        console.warn('emitIdCompanyClient(0) entfernen!');
        this.emitIdCompanyClient(0);
        this.emitResetCompanyClient();

        this.emitIdUserCaller(0);
        this.emitIdUserClient(0);
        this.resetCall();

        if (this.login.companyCallCenter.acdTyp !== '' &&  this.login.acdKey !== '') {
          setTimeout(this.acdResetStatus, ACD_RESET_STATUS_TIMER)
        }
        cbOk();
        

      }, (response) => {
      // error callback
        if (this.login.companyCallCenter.acdTyp !== '' &&  this.login.acdKey !== '') {
          // setTimeout(this.acdResetStatus, ACD_RESET_STATUS_TIMER)
        }
        cbErr(response);

      });
    },

    callCancel: function () {
        console.warn('emitIdCompanyClient(0) entfernen!');
        this.emitIdCompanyClient(0);
        this.emitResetCompanyClient();

        this.emitIdUserCaller(0);
        this.emitIdUserClient(0);
        this.resetCall();

        if (this.login.companyCallCenter.acdTyp !== '' &&  this.login.acdKey !== '') {
          setTimeout(this.acdResetStatus, ACD_RESET_STATUS_TIMER)
        }
    },

    acdResetStatus:  function (type) {
      this.$http.post(this.config.path + '/acd/status/reset/' +  this.login.companyCallCenter.acdTyp + '/' + this.login.acdKey , null).then((response) => {
        //console.log(JSON.stringify(response.body, null, 2));
      }, (response) => {
      // error callback
      });
    },
    

  } 
  
});
  


// WEBPACK FOOTER //
// ./src/common/bus.js